//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex';
import diffTable from '@/components/diff/diffTable.vue';
import CodeDiff from '@/components/codeDiff';
import { getData, getAllNodes, filterTree } from '../data';
const operateTypes = [
  { value: 'CREATE', label: '新增' },
  { value: 'MODIFY', label: '修改' },
  { value: 'DELETE', label: '删除' },
];
export default {
  components: {
    diffTable,
    CodeDiff,
  },
  data() {
    return {
      modelInfo: {
        object: '对象',
        fields: '字段',
        indexes: '索引',
      },
      operateTypes,
      asyncForm: {
        operator: operateTypes.map((item) => {
          return item.value;
        }),
      },
      loading: false,
      tableData: {},
      sync_id: '',
      DiffObject: [],
      filterDiffData: [],
      defaultProps: {},
      checkList: {},
      checkedNodes: [],
      fails: [],
      showFails: false,
      tipDaig: {
        visible: false,
        asyncData: [],
      },
      difDialog: {
        visible: false,
        oldStr: '',
        newStr: '',
        title: '',
      },
    };
  },
  computed: {
    ...mapGetters('user', ['getElementList']),
    jurisdiction() {
      return {
        asyncMeta: this.getElementList.includes('async-meta'),
      };
    },
    allKeys() {
      return this.filterDiffData
        .map((item) => {
          return item.children.map((item2) => {
            if (['indexes', 'fields'].includes(item2.label)) {
              return item2.children.map((item3) => {
                return item3.diff_id || '';
              });
            }
            return item2.diff_id || '';
          });
        })
        .join()
        .split(',')
        .filter((item) => item);
    },
    allNodes() {
      return getAllNodes(this.filterDiffData);
    },
  },
  async created() {
    this.init();
  },
  methods: {
    handleCheckAllChange() {
      const operator = this.asyncForm.operator.filter((item) => {
        return item !== '全选';
      });

      if (operator.length < operateTypes.length) {
        this.asyncForm.operator = operateTypes.map((item) => {
          return item.value;
        });
      } else {
        this.asyncForm.operator = [];
      }
    },
    changeSelect() {
      this.loading = true;
      setTimeout(() => {
        this.filterDiffData = filterTree(this.DiffObject, this.asyncForm.operator);
        this.resetChecked();
        this.$nextTick(() => {
          this.loading = false;
        });
      }, 300);
    },
    showDiff({ oldStr, newStr, title }) {
      this.difDialog = {
        visible: true,
        oldStr,
        newStr,
        title,
      };
    },
    selectAll() {
      this.checkedNodes = this.allNodes;
      this.checkList = [...this.allKeys];
      this.$refs.tree.setCheckedKeys(this.allKeys);
    },
    resetChecked() {
      this.checkList = [];
      this.checkedNodes = [];
      this.$refs.tree.setCheckedKeys([]);
    },
    init() {
      const { env, tag, tenant_id } = this.$route.query;
      if (!env || !tag || !tenant_id) {
        this.$router.replace({
          name: 'versions',
        });
      }
      this.sync_id = '';
      this.checkList = {};
      this.fails = [];
      this.getDiff(env, tag, tenant_id);
    },
    async getDiff(env, tag, tenant_id) {
      this.loading = true;
      try {
        this.$request({
          url: this.$api.metaDiffMetadataByTag,
          data: {
            env,
            tag,
            tenant_id,
          },
          cb: ({ items, sync_id: syncId }) => {
            this.DiffObject = getData(items);
            this.filterDiffData = this.DiffObject;
            this.sync_id = syncId;
            this.loading = false;
          },
        });
      } catch (err) {
        console.log(err);
        this.loading = false;
      }
    },
    handleCheckChange(data, { checkedKeys, checkedNodes }) {
      this.checkedNodes = checkedNodes.filter((item) => {
        return item.tier && item.diff_id;
      });
      this.checkList = checkedKeys.filter((item) => {
        return item;
      });
    },
    getAsyncData() {
      if (!Array.isArray(this.checkList) || this.checkList.length === 0) {
        this.$message({
          type: 'warning',
          message: '请选择数据后,执行同步操作',
        });
        return;
      }
      console.log(this.checkedNodes);
      const asyncData = {};

      this.checkedNodes.forEach((node) => {
        const { action, tier } = node;
        if (!asyncData[tier]) {
          asyncData[tier] = {};
        }
        if (!asyncData[tier][action]) {
          asyncData[tier][action] = 0;
        }
        asyncData[tier][action]++;
      });
      this.tipDaig.asyncData = [];
      ['object', 'fields', 'indexes'].forEach((tier) => {
        if (asyncData[tier]) {
          this.tipDaig.asyncData.push({
            tier,
            data: asyncData[tier],
          });
        }
      });
      this.tipDaig.visible = true;
    },
    operation() {
      try {
        this.$request({
          url: this.$api.metaSyncMetadataByTag,
          data: {
            sync_id: this.sync_id,
            diff_ids: this.checkList,
          },
          cb: ({ fails }) => {
            if (fails && fails.length > 0) {
              this.fails = fails;
              this.showFails = true;
              return;
            }
            this.$message({
              message: '同步成功',
              type: 'success',
            });
            this.tipDaig.visible = false;
            this.init();
          },
        });
      } catch (err) {
        console.log(err);
      }
    },
    closeFails() {
      this.showFails = false;
      this.init();
    },
  },
};
